import { type ComponentType, useState } from "react";
import TransitionGroup from "react-transition-group/TransitionGroup";
import CSSTransition from "react-transition-group/CSSTransition";
import { createNodeRefs } from "@/common/nodeRefs";

type BadgeButtonProps = {
  icon: ComponentType<{ className?: string }>;
  iconName?: string;
  value?: number | string;
  hasBadge?: boolean;
  className?: string;
  badgeClassName?: string;
  iconClassName?: string;
  transitionName?: string;
  onClick?: () => void;
};

export default function BadgeButton({
  icon: Icon,
  iconName,
  value = 0,
  hasBadge = true,
  className,
  badgeClassName,
  iconClassName,
  transitionName,
  onClick,
}: BadgeButtonProps) {
  // One stable nodeRef per badge value, so an exiting badge keeps its own.
  const [nodeRefFor] = useState(() => createNodeRefs<HTMLDivElement>());

  const classNames = `button square${className && className.length > 0 ? ` ${className}` : ""}`;
  let badgeClassNames = `badge${badgeClassName && badgeClassName.length > 0 ? ` ${badgeClassName}` : ""}`;
  const iconClassNames = `centered icon-${iconName}-d${iconClassName && iconClassName.length > 0 ? ` ${iconClassName}` : ""}`;

  if (hasBadge === false) {
    badgeClassNames += " no-badge";
  }

  const nodeRef = nodeRefFor(String(value));

  return (
    <button className={classNames} onClick={() => onClick?.()}>
      <TransitionGroup>
        <CSSTransition
          key={value}
          nodeRef={nodeRef}
          classNames={transitionName}
          timeout={{ enter: 500, exit: 1000 }}
        >
          <div className={badgeClassNames} ref={nodeRef}>
            <span>{value}</span>
          </div>
        </CSSTransition>
      </TransitionGroup>
      <Icon className={iconClassNames} />
    </button>
  );
}
